// extracted by mini-css-extract-plugin
module.exports = {"card_footer":"ChangePasswordForm_card_footer__9Qyjv","card_content":"ChangePasswordForm_card_content__PRQNY"};